module.exports = __webpack_public_path__ + "assets/img/oval.8a200d46.svg";